<section class="section-pad">
  <div class="container">

    <div class="faq-head">
      <p class="eyebrow">{{ eyebrow }}</p>
      <h2 class="section">{{ heading }} <span class="em">{{ headingEm }}</span></h2>
    </div>

    <div class="faq-list">
      <details class="faq-item" *ngFor="let item of items" [attr.open]="item.defaultOpen ? '' : null">
        <summary class="faq-summary">
          <span>{{ item.question }}</span>
          <span class="faq-icon" aria-hidden="true"></span>
        </summary>
        <div class="faq-body">
          <p>{{ item.answer }}</p>
        </div>
      </details>
    </div>

  </div>
</section>
